import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from './routes/Home.vue'
import MobileView from './routes/MobileHome.vue'
import NotFound from './routes/NotFound.vue'

Vue.use(VueRouter)

const beforeEnter = function (to, from, next) {
  // console.log({ to, from })
  const { uri } = to.query
  if (uri != null && uri != '/') {
    next(false)
    Router.push(uri)
  } else {
    next()
  }
}

const routes = [
  { path: '/', name: 'home', component: Home, beforeEnter },
  { path: '/mobile', name: 'mobileView', component: MobileView, beforeEnter },
  // { path: '/admin', name: 'admin', component: Home, beforeEnter },
  // { path: '/super-admin', name: 'superAdmin', component: Home, beforeEnter },
  // { path: '/expenses', name: 'expenses', component: Home, beforeEnter },
  // { path: '/leaves', name: 'holidays', component: Home, beforeEnter },
  // { path: '/timesheet', name: 'timelogs', component: Home, beforeEnter },
  // { path: '/staffing', name: 'staffinglogs', component: Home, beforeEnter },
  // { path: '/staffing-panel', name: 'staffing', component: Home, beforeEnter },
  // { path: '/assetboard', name: 'assetboard', component: Home, beforeEnter },
  // { path: '/projects-tracker', name: 'projects', component: Home, beforeEnter },
  // { path: '/reports', name: 'reports', component: Home, beforeEnter },
  // { path: '/hangfire', name: 'hangFire', component: HangFire, beforeEnter },
  { path: '*', name: 'NotFound', component: NotFound, beforeEnter }
]

const Router = new VueRouter({
  mode: 'history',
  routes
})

export default Router
